import { render, staticRenderFns } from "./ausbildung.vue?vue&type=template&id=50f627e3&scoped=true&"
import script from "./ausbildung.vue?vue&type=script&lang=js&"
export * from "./ausbildung.vue?vue&type=script&lang=js&"
import style0 from "./ausbildung.vue?vue&type=style&index=0&id=50f627e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f627e3",
  null
  
)

export default component.exports